module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門6_5.fa4af4e5.png";